import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1caee36e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {bool} from 'vue-types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TextWithTag',
  props: {
        isFunnelStrategy: bool().def(false),
    },
  setup(__props) {

const props = __props;

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", {
    class: _normalizeClass(['profile-text-with-tag__header', {'profile-text-with-tag__header--strategy': props.isFunnelStrategy}])
  }, [
    _renderSlot(_ctx.$slots, "text-before-tag"),
    _hoisted_1,
    _renderSlot(_ctx.$slots, "text-with-tag")
  ], 2))
}
}

})